import moment from "moment";
import { useEffect, useState } from "react";
import { Progress } from "reactstrap";
import { Regularize } from "../../../assets/images";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { reverseDate } from "../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  tableHeader: TableHeadersType[];
  data: any;
  handleToggleSendRegularizeApprovalData: (data: any) => void;
};

const CheckinCheckOutAttendanceTableData = ({
  data,
  tableHeader,
  handleToggleSendRegularizeApprovalData,
}: AppProps) => {
  const [currentMonthApproveData, setCurrentMonthApproveData] =
    useState<number>(0);

  useEffect(() => {
    const currentMonth = moment().format("YYYY-MM");

    const totalSum = data?.reduce((acc: any, el: any) => {
      const inputMonth = moment(el?.date).format("YYYY-MM");
      const isSameMonth = inputMonth === currentMonth;
      if (isSameMonth) {
        return acc + (el?.is_regularize || el?.is_regularize === 0 ? 1 : 0);
      }
      return acc;
    }, 0);

    setCurrentMonthApproveData(totalSum);
  }, [data]);

  return (
    <>
      {data?.length > 0 &&
        data?.map((el: any) => {
          const inputDate = el?.date;
          const currentDate = moment(new Date()).format("YYYY-MM-DD");
          const isSameDate = inputDate === currentDate;
          // Compare only the date part
          const inputMonth = moment(inputDate).format("MM");
          const currentMonth = moment(currentDate).format("MM");
          const isSameMonth = inputMonth === currentMonth;

          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "date") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "100px" }}
                      >
                        {el?.date ? reverseDate(el?.date) : "NA"}
                      </td>
                    );
                  } else if (header?.value === "in_time") {
                    return (
                      <td className="text-left mt-5">
                        {el?.start_time ? el?.start_time : "NA"}
                      </td>
                    );
                  } else if (header?.value === "out_time") {
                    return (
                      <td className="text-left mt-5">
                        {el?.end_time ? el?.end_time : "NA"}
                      </td>
                    );
                  } else if (header?.value === "total_work_hours") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "180px" }}
                      >
                        <div className="d-flex align-items-center">
                          <Progress
                            striped
                            style={{
                              height: "15px",
                              marginRight: "10px",
                              width: "100px",
                              backgroundColor: "#bfcbe1",
                            }}
                            value={el?.total_hours}
                            max={12}
                            color={"success"}
                          ></Progress>
                          <span>{`${el?.total_hours?.toFixed(2)}/12hrs`}</span>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "start_location") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "300px" }}
                      >
                        {el?.start_location ? el?.start_location : "NA"}
                      </td>
                    );
                  } else if (header?.value === "end_location") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "300px" }}
                      >
                        {el?.start_location ? el?.end_location : "NA"}
                      </td>
                    );
                  } else if (header?.value === "action") {
                    return (
                      <td className="text-left mt-5">
                        <span
                          className="text-danger"
                          style={{
                            textDecoration: "underline",
                            textUnderlineOffset: "2px",
                            opacity:
                              !isSameMonth ||
                              el?.is_regularize !== null ||
                              currentMonthApproveData === 3 ||
                              !el?.end_time ||
                              el?.total_hours > 9 ||
                              isSameDate
                                ? "0.5"
                                : "",
                            cursor:
                              !isSameMonth ||
                              el?.is_regularize !== null ||
                              currentMonthApproveData === 3 ||
                              !el?.end_time ||
                              el?.total_hours > 9 ||
                              isSameDate
                                ? "default"
                                : "pointer",
                          }}
                          onClick={() =>
                            el?.is_regularize === null &&
                            currentMonthApproveData !== 3 &&
                            el?.end_time &&
                            el?.total_hours < 9 &&
                            !isSameDate &&
                            handleToggleSendRegularizeApprovalData({
                              ...el,
                              currentMonthApproveData,
                            })
                          }
                        >
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-download-invoice">
                                {!isSameMonth
                                  ? "Regularisation is not allowed for dates in the previous month."
                                  : isSameDate
                                  ? "You cannot regularise today's date."
                                  : el?.total_hours >= 9
                                  ? "Regularisation is not allowed if total hours are 9 or more"
                                  : el?.is_regularize === 0
                                  ? "Pending for Approval"
                                  : el?.is_regularize == null && el?.end_time
                                  ? "Add Regularise"
                                  : el?.is_regularize === 1
                                  ? "Regularised"
                                  : "Regularise"}
                              </Tooltip>
                            }
                          >
                            <img src={Regularize} alt="regularize" />
                          </OverlayTrigger>
                        </span>
                        {/* ) : (
                          "NA"
                        )} */}
                      </td>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default CheckinCheckOutAttendanceTableData;
